import { db } from ".";
import { getDocs, collection, query, where, getDoc, doc } from 'firebase/firestore'

export const getCapitulos = (capitulosId) => {
    return new Promise((resolve, reject) => {
        const collectionRef = capitulosId 
            ? query(collection(db, 'capitulos'), where('id', '==', capitulosId)) 
            : collection(db, 'capitulos')

            getDocs(collectionRef).then(response => {
                const capitulos = response.docs.map(doc => {
                    return { id: doc.id, ...doc.data() }
                })
                resolve(capitulos)
            }).catch(error => {
                reject(error)
            })
    })
}

export const getCategories = (categoryId) => {
    return new Promise((resolve, reject) => {
        const collectionRef = categoryId 
            ? query(collection(db, 'categorias'), where('categoria', '==', categoryId)) 
            : collection(db, 'categorias')

            getDocs(collectionRef).then(response => {
                const categories = response.docs.map(doc => {
                    return { id: doc.id, ...doc.data() }
                })
                resolve(categories)
            }).catch(error => {
                reject(error)
            })
    })
}

export const getProducts = (categoryId) => {
    return new Promise((resolve, reject) => {
        const collectionRef = categoryId 
            ? query(collection(db, 'clientes'), where('categoria', '==', categoryId)) 
            : collection(db, 'clientes')

            getDocs(collectionRef).then(response => {
                const products = response.docs.map(doc => {
                    return { id: doc.id, ...doc.data() }
                })
                resolve(products)
            }).catch(error => {
                reject(error)
            })
    })
}

export const getProduct = (productId) => {
    return new Promise((resolve, reject) => {
            getDoc(doc(db, 'clientes', productId)).then(response => {
                const product = { id: response.id, ...response.data()}
                resolve(product)
            }).catch(error => {
                reject(error)
            })
    })
} 

export const getObra = (obraId) => {
    return new Promise((resolve, reject) => {
            getDoc(doc(db, 'obra', obraId)).then(response => {
                const obra = { id: response.id, ...response.data()}
                resolve(obra)
            }).catch(error => {
                reject(error)
            })
    })
}